import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { get } from 'lodash';
import onHandleTap from './onHandleTap';
import { getAnswerClass } from '../Matrix/utils';
import AttributeValues from '../../Answers/AttributeValues';
import { escapeHTML } from '../../../utils';

export default function MatrixMaxDiff({ question, currentChoiceSet }) {
  const handleTap = useCallback(onHandleTap, []);

  useEffect(() => {
    // TODO: this needs handling for when we fix conjoint validations
    // TODO2: we need to remove the store sideEffect somehow
    Pollfish.store.shuffledAnswers = [...currentChoiceSet.conceptAnswers];
  }, []);

  const textLabelBest = get(question, 'matrix.columns[0].beforeLabel', '');
  const textLabelWorst = get(question, 'matrix.columns[1].beforeLabel', '');
  return (
    <div className="answers">
      {currentChoiceSet.conceptAnswers.map((conceptAnswer) => (
        <div
          key={conceptAnswer.id}
          id={conceptAnswer.id}
          className={classNames(
            'answer answer--max-diff answerClick text-center',
            getAnswerClass({ question }),
          )}
        >
          <AttributeValues values={conceptAnswer.attributeValues} />
          <div className="answer--max-diff-actions">
            {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-noninteractive-element-interactions */}
            <p
              className="answer--max-diff-best"
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: escapeHTML(textLabelBest) || '&nbsp;',
              }}
              onClick={handleTap}
            ></p>
            {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-noninteractive-element-interactions */}
            <p
              className="answer--max-diff-worst"
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: escapeHTML(textLabelWorst) || '&nbsp;',
              }}
              onClick={handleTap}
            ></p>
          </div>
        </div>
      ))}
    </div>
  );
}

MatrixMaxDiff.propTypes = {
  question: PropTypes.object,
  currentChoiceSet: PropTypes.object,
};
